export default "attribute float data_value;\n\nvarying float v_value;\n\nvoid main() {\n  v_value = data_value;\n  gl_Position = vec4(position, 1.0);\n}";